module.exports = __webpack_public_path__ + "img/9.26fc1fd2.png";